import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import DeleteModal from "Common/DeleteModal";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import ReadyLoadColumnData from "Common/Components/ReadyLoadColumnData";
import { getRoleId, getUsername } from "Common/Components/getRoleId";
import ReadyLoadColumnDriver from "Common/Components/ReadyLoadColumnData/ReadyLoadColumnDriver";
import SearchHeader from "Common/Components/AllComponetnReadyLoad/SearchHeader";
import CarriageTable from "Common/Components/AllComponetnReadyLoad/CarriageTable";
import CarriageFormModal from "Common/Components/AllComponetnReadyLoad/CarriageFormModal";
import { DEFAULT_CROP_YEAR_ID } from "Common/constants/cropYear";
const ReadyLoad = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>(false);
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [IsEdit, setIsEdit] = useState<any>();
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [selectedFarmer, setSelectedFarmer] = useState<any>(null);
  const [selectedvillage, setSelectedvillage] = useState<any>(null);
  const [selectedorigin, setSelectedorigin] = useState<any>(null);
  const [selectedDistanation, setSelectedDistanation] = useState<any>(null);
  const cropyearID = Number(localStorage.getItem("crop_year_id"));
  const [CaringID, setCaringID] = useState<any>("");
  const [role, setRole] = useState<any>(null);
  const token = localStorage.getItem("app_atkey");
  const user_id = getUsername(token);
  const [Datevalues, setDatevaluesValues] = useState<DateObject | null>(
    new DateObject({ calendar: persian }).setLocale(persian_fa)
  );
  const [userinfo, setUserInfo] = useState<any>(null);
  const [commitID, setCommitID] = useState<any>(null);
  const [weight, setWeight] = useState<string>("");
  const [transportCost, setTransportCost] = useState<string>("");
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  // FOR PAGINATION ✈
  const handleSelect = (value: number) => {
    setSelectedNumber(value);
    const newSize = value;
    const totalItems = alldata ? Number(alldata) : 0;
    let newPage = currentPage;
    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }
    setCurrentPage(newPage);
    fetchData(newPage, newSize);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, selectedNumber, reload, searchValue, sortState]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Get main Data
  const fetchData = async (page: any, size: any) => {
    setload(true);
    try {
      let url = `https://api.havirkesht.ir/carriage/?sort_by=updated_at&sort_order=desc&size=${size}&page=${page}&crop_year_id=${
        cropyearID === 0 ? DEFAULT_CROP_YEAR_ID : cropyearID
      }`;
      if (sortState.name) {
        if (sortState.step === 2) {
          url += `&sort_by=${sortState.name}&sort_order=desc`;
        } else {
          url += `&sort_by=${sortState.name}&sort_order=${sortState.order}`;
        }
      }
      if (searchValue && searchValue.trim() !== "") {
        url += `&search=${encodeURIComponent(searchValue.trim())}`;
      }
      const res: any = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });
      const items = res?.data?.items || [];
      setData(items);
      setalldata(res?.data?.total);
      setTotalPages(res?.data?.pages);
      setload(items.length < 1);
    } catch (error: any) {
      setData("");
      console.error("Error fetching data:", error);
      setload(false);
    }
  };

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    console.log(cell);
    if (cell.id) {
      setEventData(Number(cell.id));
    }
  };
  // covert to latin numbers
  const convertPersianToEnglishNumbers = (str: string): string => {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    return str.replace(/[۰-۹]/g, (d) => {
      const index = persianNumbers.indexOf(d);
      return englishNumbers[index];
    });
  };
  // update data function
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });
    setIsEdit(true);
    setCaringID(ele.id);
    setSelectedFarmer({
      id: ele.farmer_id,
      farmer_name: ele.farmer_name,
    });
    setWeight(ele.weight?.toString() || "");
    setTransportCost(ele.carriage_fee_per_ton?.toString() || "");
    setSelectedvillage({
      id: ele.village_id,
      village: ele.village_name,
    });

    setSelectedorigin({
      id: ele.origin_id,
      city: ele.origin_city,
    });

    setSelectedDistanation({
      id: ele.destination_id,
      city: ele.destination_city,
    });

    // تبدیل تاریخ به فرمت مناسب برای DatePicker
    if (ele.loading_date) {
      const dateParts = ele.loading_date.split("/");
      if (dateParts.length === 3) {
        const dateObject = new DateObject({
          year: parseInt(dateParts[0]),
          month: parseInt(dateParts[1]),
          day: parseInt(dateParts[2]),
          calendar: persian,
        }).setLocale(persian_fa);
        setDatevaluesValues(dateObject);
      }
    }

    setShow(true);
  };
  useEffect(() => {
    const userId = getUsername(token);
    const roleID = getRoleId(token);
    if (roleID === 5) {
      const fetchUserInfo = async () => {
        try {
          const token = localStorage.getItem("app_atkey");
          if (!userId) {
            console.error("User ID not found in localStorage");
            return;
          }

          const response = await axios.get(
            `https://api.havirkesht.ir/users/${userId}`
          );
          setUserInfo(response.data);
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      };

      fetchUserInfo();
    }
  }, []);
  // Delete data function
  const handleDelete = async () => {
    if (!eventData) {
      toast.error("داده‌ای برای حذف انتخاب نشده است");
      setDeleteModal(false);
      return;
    }
    try {
      setDeleteModal(false);
      const evenDataNumber = Number(eventData);
      if (isNaN(evenDataNumber)) {
        toast.error("شناسه  معتبر نیست");
        return;
      }
      const res = await axios.delete(
        `https://api.havirkesht.ir/carriage/${evenDataNumber}`
      );
      if (res.status === 200) {
        Swal.fire({
          title: "حذف کشاورز",
          text: "عملیات حذف با موفقیت انجام شد",
          icon: "success",
        });
        setreload(!reload);
      }
    } catch (error: any) {
      Swal.fire({
        title: "مشکلی در حذف این فیلد",
        text: "شما نمیتوانید این داده را حذف کنید لطفا با مدیر سایت تماس بگیرید",
        icon: "error",
      });
    } finally {
      setEventData(null);
    }
  };

  // Delete data function
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (!selectedFarmer) {
      toast.error("لطفاً یک کشاورز انتخاب کنید");
      return;
    }
    validation.handleSubmit();
  };

  // GET ROLE USER
  useEffect(() => {
    setRole(getRoleId(token));
  }, [token]);

  // submit function
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      transportCost: IsEdit ? transportCost : "",
      weight: IsEdit ? weight : "",
    },
    validationSchema: Yup.object({
      transportCost: Yup.string().required("این فیلد ضروری است"),
      weight: Yup.string().required("این فیلد ضروری است"),
    }),
    onSubmit: async (values) => {
      if (
        !selectedFarmer ||
        !selectedvillage ||
        !selectedorigin ||
        !selectedDistanation
      ) {
        return Swal.fire(
          "خطا در ثبت",
          "لطفا تمام موارد رو انتخاب کنید",
          "error"
        );
      }
      try {
        if (IsEdit) {
          try {
            const UpdateData = {
              weight: values.weight,
              farmer_id: Number(selectedFarmer?.id),
              village_id: selectedvillage.id,
              origin_id: selectedorigin.id,
              destination_id: selectedDistanation.id,
              carriage_fee_per_ton: values.transportCost,
              crop_year_id: cropyearID, // اضافه کردن این فیلد
              loading_date: Datevalues
                ? convertPersianToEnglishNumbers(
                    Datevalues.format("YYYY/MM/DD")
                  )
                : null,
            };
            const res = await axios.put(
              `https://api.havirkesht.ir/carriage/${CaringID}`,
              UpdateData,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            if (res.status == 200) {
              Swal.fire({
                title: "عملیات با موفقیت بروزرسانی شد",
                text: "عملیات بروزرسانی داده با موفقیت ثبت شد",
                icon: "success",
              });
              setreload(!reload);
              setload(false);
              restForm();
            }
          } catch (error) {
            console.log(error);
            setload(false);
            toast.error(`خطا در بروزرسانی داده`);
          }
        } else {
          const newData = {
            weight: values.weight,
            farmer_id: Number(selectedFarmer.farmer_id),
            village_id: selectedvillage.id,
            origin_id: selectedorigin.id,
            destination_id: selectedDistanation.id,
            carriage_fee_per_ton: values.transportCost,
            crop_year_id: cropyearID, // اضافه کردن این فیلد
            loading_date: Datevalues
              ? convertPersianToEnglishNumbers(Datevalues.format("YYYY/MM/DD"))
              : null,
          };
          const res = await axios.post(
            "https://api.havirkesht.ir/carriage/",
            newData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (res.status === 201) {
            Swal.fire({
              title: "عملیات با موفقیت ثبت شد",
              text: "عملیات ثبت داده با موفقیت انجام شد",
              icon: "success",
            });
            setreload(!reload);
            setload(false);
            restForm();
          } else {
            setload(false);
            toast.success(`خطا در ثبت`);
          }
          toggle();
        }
      } catch (error: any) {
        console.error("Operation failed:", error);
        Swal.fire({
          title: "عملیات با خطا مواجه شد",
          text: "عملیات ثبت داده با خطا مواجه شد",
          icon: "error",
        });
      }
    },
  });
  // reset Form function
  function restForm() {
    setIsEdit(false);
    setCommitID(null);
    setShow(false);
    setEventData("");
    validation.resetForm();
    setWeight("");
    setIsEdit(false);
    setSelectedFarmer(null);
    setSelectedvillage(null);
    setSelectedorigin(null);
    setSelectedDistanation(null);
    setTransportCost("");
  }

  // for show and hide modal
  const toggle = useCallback(() => {
    if (show) {
      restForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  // for sorting
  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  // for sorting
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };

  // درخواست حمل بار
  const RequestCarringLoad = async (data: any) => {
    if (role !== 5) {
      return Swal.fire(
        "محدودیت درخواست",
        "شما مجاز به ثبت حمل بار نیستید فقط رانندگان  مجاز به ثبت درخواست حمل بار هستند",
        "error"
      );
    } else {
      const res66 = await axios.get(
        `https://api.havirkesht.ir/driver/by_user/${user_id}`
      );
      const dirverFullname = `${res66?.data?.name} ${res66?.data?.last_name}`;
      const driverConfirmationMessage = `راننده گرامی آقای ${dirverFullname}. با تایید این درخواست متعهد به حمل بار کشاورز آقای ${data.farmer_name} می‌شوید و لازم است برای بارگیری به محل بار واقع در روستای ${data.village_name} مراجعه کنید. آیا از ثبت این درخواست مطمئن هستید؟`;
      Swal.fire({
        title: "تایید درخواست حمل",
        text: driverConfirmationMessage,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        customClass: {
          confirmButton:
            "bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg mx-2 my-1 transition-all duration-200 shadow-md hover:shadow-lg",
          cancelButton:
            "bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg mx-2 my-1 transition-all duration-200 shadow-md hover:shadow-lg",
          popup: "rounded-2xl p-6 dark:bg-gray-800",
          title: "text-xl font-bold text-gray-800 dark:text-white",
          htmlContainer: "text-gray-600 dark:text-gray-300 text-lg leading-7",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const getUserID = getUsername(token);
          try {
            const res = await axios.post(
              `https://api.havirkesht.ir/carriage_status/`,
              {
                carriage_id: data.id,
                driver_id: user_id,
                carried: true,
              }
            );
            if (res.status == 201) {
              Swal.fire(
                "عملیات موفقیت",
                "درخواست حمل بار با موفقیت ثبت شد",
                "success"
              );
              setreload(!reload);
            }
            try {
              const smsDriver = await axios.post(
                `https://api.havirkesht.ir/sms/driver-carriage-notification/${getUserID}/${data.id}`
              );
              const smsFarmer = await axios.post(
                `https://api.havirkesht.ir/sms/farmer-carriage-confirmation/${getUserID}/${data.id}`
              );
              const smsPimanKar = await axios.post(
                `https://api.havirkesht.ir/sms/contractor-carriage-confirmation/${getUserID}/${data.id}`
              );
              console.log("sms ", smsDriver, smsFarmer, smsPimanKar);
            } catch (error) {
              console.log(error);
            }
          } catch (error: any) {
            if (error.status == 403) {
              return Swal.fire(
                "خطا ",
                "شما فقط مجاز به ثبت درخواست حمل بار خودتان هستید",
                "error"
              );
            } else if (error.status == 429) {
              return Swal.fire(
                "خطا ",
                "شما فقط میتوانید هر 24 ساعت یک بار درخواست حمل بار کنید ",
                "error"
              );
            }
            console.log(error);
            Swal.fire("عملیات خطا", "درخواست حمل بار با خطا مواجه شد", "error");
          }
        } else {
          console.log("درخواست لغو شد");
        }
      });
    }
  };
  // درخواست لغو بار
  const cancelRequest = async (data: any) => {
    const role = getRoleId(token);
    if (role !== 1) {
      return Swal.fire(
        "محدودیت درخواست",
        "راننده گرامی بار فقط توسط پیمان کار لغو میتواند شود لطفا برای لغو بار با پیمانکار سجاد رشنو تماس بگیرید",
        "error"
      );
    }
    const result = await Swal.fire({
      title: "لغو درخواست",
      text: "آیا از لغو درخواست حمل بار اطمینان دارید؟",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: {
        confirmButton:
          "bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg mx-2 my-1 transition-all duration-200 shadow-md hover:shadow-lg",
        cancelButton:
          "bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded-lg mx-2 my-1 transition-all duration-200 shadow-md hover:shadow-lg",
        popup: "rounded-2xl p-6 dark:bg-gray-800",
        title: "text-xl font-bold text-gray-800 dark:text-white",
        htmlContainer: "text-gray-600 dark:text-gray-300 text-lg leading-7",
      },
      buttonsStyling: false,
    });

    if (!result.isConfirmed) {
      console.log("درخواست لغو شد");
      return;
    }
    try {
      const res = await axios.delete(
        `https://api.havirkesht.ir/carriage_status/${Number(
          data.carriage_status_id
        )}`
      );
      if (res.status === 200) {
        Swal.fire("عملیات موفقیت", "درخواست لغو با موفقیت ثبت شد", "success");
        setreload(!reload);

        await CanselSms(data.id.toString(), data.driver_id?.toString() || null);
      }
    } catch (error: any) {
      console.error("خطا در لغو درخواست:", error);
      if (error.response?.status === 404) {
        Swal.fire("خطا", "درخواست مورد نظر یافت نشد", "error");
      } else if (error.response?.status === 403) {
        Swal.fire("خطا", "شما مجاز به لغو این درخواست نیستید", "error");
      } else {
        Swal.fire("عملیات خطا", "درخواست لغو با خطا مواجه شد", "error");
      }
    }
  };
  // Cansel Sms
  const CanselSms = async (mainID: string, driverID: string | null) => {
    try {
      if (!mainID || !driverID) {
        console.error("مقادیر mainID یا driverID وجود ندارد");
        toast.error("راننده یافت نشد مشکلی در ارسال پیامک به وجود امده است");
        return;
      }
      await Promise.all([
        axios.post(
          `https://api.havirkesht.ir/sms/driver-carriage-cancelled/${mainID}/${driverID}`
        ),
        axios.post(
          `https://api.havirkesht.ir/sms/farmer-carriage-cancelled/${mainID}/${driverID}`
        ),
        axios.post(
          `https://api.havirkesht.ir/sms/contractor-carriage-cancelled/${mainID}/${driverID}`
        ),
      ]);
    } catch (smsError) {
      console.error("خطا در ارسال پیامک‌ها:", smsError);
      Swal.fire(
        "عملیات لفو با موفقیت (مشکلی در ارسال پیامک به وجود امده است ارسال پیامک)",
        "درخواست لغو ثبت شد اما ارسال برخی پیامک‌ها با مشکل مواجه شد",
        "warning"
      );
    }
  };
  // ccolumn data
  const columns =
    role === 1
      ? ReadyLoadColumnData({
          handleUpdateDataClick,
          onClickDelete,
          columnName,
          RequestCarringLoad,
          cancelRequest,
        })
      : ReadyLoadColumnDriver({
          RequestCarringLoad,
          cancelRequest,
          columnName,
          userinfo,
        });

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت کشاورز" title="هاویر کشت" />

      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />

      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />

      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <SearchHeader
            totalItems={Number(alldata)}
            searchValue={searchValue}
            onSearchChange={setsearchValue}
            onSelectNumber={handleSelect}
            onAddNew={toggle}
            showAddButton={getRoleId(token) === 1 ? true : false}
          />

          <CarriageTable
            data={data}
            columns={columns}
            loading={load}
            error={"داده ای یافت نشد"}
            currentPage={currentPage}
            totalPages={totalPages}
            selectedNumber={selectedNumber}
            onPageChange={handlePageChange}
            sortState={sortState}
            onResetSort={resetSorting}
          />
        </div>
      </div>

      <CarriageFormModal
        show={show}
        isEdit={IsEdit}
        commitID={commitID}
        setCommitID={setCommitID}
        onHide={toggle}
        onSubmit={handleClick}
        validation={validation}
        selectedFarmer={selectedFarmer}
        selectedVillage={selectedvillage}
        selectedOrigin={selectedorigin}
        selectedDestination={selectedDistanation}
        dateValue={Datevalues}
        onDateChange={setDatevaluesValues}
        onFarmerChange={setSelectedFarmer}
        onVillageChange={setSelectedvillage}
        onOriginChange={setSelectedorigin}
        onDestinationChange={setSelectedDistanation}
      />
    </React.Fragment>
  );
};
export default ReadyLoad;
